import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { ConfirmDialog } from "security-app/components/common/Modal";
import AlertDetails from "./AlertDetails";
function SystemAlertsDetails({ notifications, onClose }) {
  return /* @__PURE__ */ React.createElement(ConfirmDialog, { show: true, onConfirm: onClose, confirmText: "Dismiss", noCancelButton: true, title: "System Alerts Details" }, notifications.map((notification) => /* @__PURE__ */ React.createElement(AlertDetails, { key: uuidv4(), notification })));
}
export default SystemAlertsDetails;
